import { getIn, remove, removeIn, setIn } from 'immutable';
import { pathForSetIn } from './path-for-set-in';
import { removeNulls } from 'utils';
//Убираем из device_tree устройства, которые дублируются
export function filterDeviceTreeFromDuplicates(device_tree) {
    const all_devices = new Set();
    function filterDuplicates(children_device_tree) {
        return removeNulls(children_device_tree.map((item) => {
            if ('Reg' in item) {
                return item;
            }
            if ('Children' in item) {
                return { ...item, Children: filterDuplicates(item.Children) };
            }
            if ('ZontId' in item && !all_devices.has(item.ZontId)) {
                //Добавляем в словарь и возвращаем
                all_devices.add(item.ZontId);
                return item;
            }
            return null;
        }));
    }
    return filterDuplicates(device_tree);
}
export function deleteDeviceInDeviceTree(device_tree, device_id) {
    return removeNulls(device_tree.map((item) => {
        if ('Reg' in item) {
            return item;
        }
        if ('Children' in item) {
            return {
                ...item,
                Children: deleteDeviceInDeviceTree(item.Children, device_id),
            };
        }
        if ('ZontId' in item) {
            if (item.ZontId === device_id) {
                return null;
            }
            return item;
        }
        return null;
    }));
}
const found_devices = new Set();
/**
 * @function
 * Убираем из device_tree устройства, которых нет в devices
 * @param device_tree - дерево устройств
 * @param devices - устройства (только id)
 * @return boolean
 */
export function filterDeviceTreeFromUnknownDevice(device_tree, devices) {
    return removeNulls(device_tree.map((item) => {
        if ('Reg' in item) {
            return item;
        }
        if ('ZontId' in item) {
            if (devices.find(({ id }) => id === item.ZontId) == null) {
                return null;
            }
            found_devices.add(item.ZontId);
            return item;
        }
        if ('Children' in item)
            return {
                ...item,
                Children: filterDeviceTreeFromUnknownDevice(item.Children, devices),
            };
        return null;
    }));
}
//Добавляем в device_tree устройства, которые есть в devices, но нет в device_tree
export function deviceTreeWithLostDevices(device_tree, devices) {
    return [
        ...filterDeviceTreeFromUnknownDevice(device_tree, devices),
        ...devices
            .filter(({ id }) => !found_devices.has(id))
            .map(({ id }) => ({
            ZontId: id,
        })),
    ];
}
//Преобразуем массив с группами к нужному нам виду
export function convertDeviceTreeForTreeData(device_tree) {
    return removeNulls(device_tree.map((item) => {
        if ('ZontId' in item) {
            return { id: item.ZontId };
        }
        if ('Reg' in item) {
            return { Reg: item.Reg };
        }
        if ('Children' in item)
            return {
                title: item.Name ?? '',
                expanded: item.Expand ?? false,
                id: item.id,
                children: convertDeviceTreeForTreeData(item.Children),
                icon: item.Icon ?? '',
            };
        return null;
    }));
}
//Преобразуем путь из видимого дерева в путь с нормальными индексами
export function visiblePath2FullPath(visible_path, device_tree) {
    let current_visible_index = 0;
    for (let node_i = 0; node_i < device_tree.length; node_i++) {
        const node = device_tree[node_i];
        if ('Reg' in node)
            continue;
        if (current_visible_index == visible_path[0]) {
            if (visible_path.length == 1)
                return [node_i];
            if ('Children' in node) {
                if (node.Children == null)
                    throw 'Found device instead of group in visiblePath2FullPath';
                return [
                    node_i,
                    ...visiblePath2FullPath(visible_path.slice(1), node.Children),
                ];
            }
        }
        current_visible_index++;
    }
    return [-1];
}
//Получаем путь из tree_data
export function pathToPath(number, tree_data) {
    const walk = (number, tree_data, counter = 0) => {
        for (let i = 0; i < tree_data.length; i++) {
            const node = tree_data[i];
            if (counter == number)
                return {
                    found_path: [i],
                    counter,
                };
            counter++;
            if ('children' in node && node.expanded) {
                const result = walk(number, node.children, counter);
                if (result.found_path)
                    return { found_path: [i, ...result.found_path], counter };
                counter = result.counter;
            }
        }
        return { counter };
    };
    const { found_path } = walk(number, tree_data);
    if (!found_path) {
        //Если устройство новое, и его не было в device_tree
        return [];
        // throw 'Not found ;(';
    }
    return found_path;
}
export function expandingGroup(data, device_tree) {
    const path = data.path;
    const tree_data = data.treeData;
    const expand = data.expanded;
    //Находим настоящий путь до группы
    const natural_path_in_device_tree = visiblePath2FullPath(pathToPath(path[path.length - 1], tree_data), device_tree);
    const group = getIn(device_tree, pathForSetIn(natural_path_in_device_tree).without_children, []);
    if ('ZontId' in group) {
        return device_tree;
    }
    return setIn(device_tree, pathForSetIn(natural_path_in_device_tree).without_children.concat('Expand'), expand);
}
export function moveItem(data, device_tree, treeItems) {
    //Находим предыдущий путь
    const old_path = visiblePath2FullPath(pathToPath(data.prevPath[data.prevPath.length - 1], treeItems), device_tree);
    const index_of_remove_item = old_path.slice(-1)[0];
    //Преобразуем путь для getIn
    const old_path_of_item = pathForSetIn(old_path);
    //Берём этот элемент
    const item = getIn(device_tree, old_path_of_item.without_children, []);
    //Находим старый путь, где лежал этот элемент
    const path_of_children_of_old_parent = old_path_of_item.without_children.slice(0, -1);
    //Берем элементы, которые были в том месте
    const children_of_old_parent = getIn(device_tree, path_of_children_of_old_parent, []);
    //Из старого пути удаляем
    const children_of_old_parent_without_item = remove(children_of_old_parent, index_of_remove_item);
    //Вставить старые элементы надо
    const device_tree_without_item = setIn(device_tree, path_of_children_of_old_parent, [...children_of_old_parent_without_item]);
    //Находим будущий путь
    const new_path = visiblePath2FullPath(pathToPath(data.nextPath[data.nextPath.length - 1], data.treeData), device_tree_without_item);
    const index_of_add_item = new_path.slice(-1);
    //Обрабатываем появление нового элемента в конце списка или группы
    if (new_path[new_path.length - 1] === -1) {
        //Надо узнать, что за элемент находится выше последнего индекса
        const path_of_parent = new_path.slice(0, -1);
        //Если пустота, значит корень
        if (path_of_parent.length === 0) {
            //Вернём дерево с новым элементом
            return setIn(device_tree_without_item, path_of_parent, [
                ...device_tree_without_item,
                item,
            ]);
        }
        //Если нет, значит группа, и нужно узнать её детей
        const path_of_parent_for_SetIn = pathForSetIn(path_of_parent);
        //Запросили её существующих детей
        const children_of_parent = getIn(device_tree_without_item, path_of_parent_for_SetIn.with_children, []);
        //Добавили к ним наш элемент и вернули новое дерево
        return setIn(device_tree_without_item, path_of_parent_for_SetIn.with_children, [
            ...children_of_parent,
            item,
        ]);
    }
    //Преобразуем новый путь getIn
    const new_path_of_item = pathForSetIn(new_path);
    //Находим новый путь, где будет лежать этот элемент
    const path_of_children_of_new_parent = new_path_of_item.without_children.slice(0, -1);
    //Берем элементы, которые были в том месте
    const children_of_new_parent = getIn(device_tree_without_item, path_of_children_of_new_parent, []);
    //Добавляем элемент и возвращаем итоговое дерево
    return setIn(device_tree_without_item, path_of_children_of_new_parent, [
        ...children_of_new_parent.slice(0, index_of_add_item),
        item,
        ...children_of_new_parent.slice(index_of_add_item),
    ]);
}
function deleteDeviceFromGroup(device_tree, devices_old_path) {
    //Находим старый путь, где лежал этот элемент
    const path_of_children_of_old_parent = pathForSetIn(devices_old_path).without_children.slice(0, -1);
    //Берем элементы, которые были в том месте
    const children_of_old_parent = getIn(device_tree, path_of_children_of_old_parent, []);
    //Из старого пути удаляем
    const children_of_old_parent_without_item = removeIn(children_of_old_parent, devices_old_path.slice(-1));
    //Вставить старые элементы надо
    return setIn(device_tree, path_of_children_of_old_parent, [
        ...children_of_old_parent_without_item,
    ]);
}
//Метод для того, чтобы переместить устройство в группу
export function moveItem_v2(device_tree, devices_old_path, parents_path) {
    if (device_tree == null)
        return [];
    // Если устройства не было в дереве
    if (devices_old_path.length === 0) {
        return device_tree;
    }
    const device_from_old_path = getIn(device_tree, pathForSetIn(devices_old_path).without_children, null);
    //Если не нашли, что переносить
    if (device_from_old_path == null)
        return device_tree;
    //Нет группы
    if (parents_path.length === 0) {
        //Значит просто надо убрать прибор из того места, где он был
        const device_tree_without_device = deleteDeviceFromGroup(device_tree, devices_old_path);
        //и положить в конец корня
        return setIn(device_tree_without_device, [], [...device_tree_without_device, device_from_old_path]);
    }
    //Находим нового родителя
    const new_parent = getIn(device_tree, pathForSetIn(parents_path).without_children, null);
    //Добавляем устройство в конец группы
    const updated_parent = setIn(new_parent, ['Children'], [...new_parent.Children, device_from_old_path]);
    //Вставляем обновлённого родителя в дерево
    const device_tree_with_updated_parent = setIn(device_tree, pathForSetIn(parents_path).without_children, updated_parent);
    //Теперь надо удалить из того места, где до этого был
    return deleteDeviceFromGroup(device_tree_with_updated_parent, devices_old_path);
}
/**
 * @function getNameFromItem - Беру элемент по его пути
 * @param path - путь
 * @param device_tree - дерево групп
 * @return DeviceTreeItem
 */
export function getItemFromPath(path, device_tree) {
    return getIn(device_tree, pathForSetIn(path).without_children, null);
}
/**
 * @function getNameFromItem - Беру элемент по его пути
 * @param path - путь до элемента
 * @param device_tree - дерево групп
 * @return string
 * Вот такого вида:
 * Корневая группа
 *   Подгруппа 1
 *     Подгруппа 2
 *       Подгруппа 3
 */
export function getGroupsNameFromPath(path, device_tree) {
    //Если только порядковый номер, значит нет группы
    if (path.length <= 1)
        return 'Нет группы';
    //Набираю массив с названиями групп
    const names = [];
    for (let i = 1; i < path.length; i++) {
        const reduce_path = path.slice(0, -i);
        const item = getItemFromPath(reduce_path, device_tree);
        names.push(item != null && 'Name' in item ? item.Name : 'Группа без названия');
    }
    //Переворачиваю его
    names.reverse();
    return names
        .map((item, index) => {
        if (index > 0)
            return ' '.repeat(2 * index) + item.replace(' ', ' ');
        return item.replace(' ', ' ');
    })
        .toString()
        .replace(/,/g, '\n');
}
/**
 * @function
 * @param item - элемент дерева групп
 * @return элементы без групп
 * Если кончилось действие платного тарифа, то выкидываю все группы
 */
export function filterDeviceTreeFromGroup(item) {
    if ('ZontId' in item || 'Reg' in item) {
        return [item];
    }
    if ('Children' in item) {
        return item.Children.flatMap(filterDeviceTreeFromGroup);
    }
    return [];
}
